import React, { useState } from "react";
import { Navbar, Nav, Container, Offcanvas } from "react-bootstrap";
import {
  Telephone,
  Envelope,
  InfoCircle,
  House,
  Building,
  PencilSquare,
  Download,
} from "react-bootstrap-icons";
import { Link, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import BBSLogo from "../../assets/images/BBSLogo.svg";
import menuItems from "../../data/mainMenuItems.json";
import "./BBS2Navbar.css";
import CartBadge from "../cart/CartBadge";

const IconMap = {
  House: <House className="me-2" aria-hidden="true" />,
  Building: <Building className="me-2" aria-hidden="true" />,
  PencilSquare: <PencilSquare className="me-2" aria-hidden="true" />,
  Download: <Download className="me-2" aria-hidden="true" />,
  InfoCircle: <InfoCircle className="me-2" aria-hidden="true" />,
};

const BBS2Navbar = () => {
  const location = useLocation();
  // State zur Steuerung des Offcanvas-Menüs
  const [expanded, setExpanded] = useState(false);

  // Funktion zum Schließen des Menüs bei Linkklick
  const handleClose = () => setExpanded(false);

  return (
    <Navbar
      expand="lg"
      expanded={expanded}
      onToggle={(isExpanded) => setExpanded(isExpanded)}
      className="bbs-navbar"
      style={{ backgroundColor: "transparent" }}
      as="header"
      role="banner"
    >
      <Container fluid className="position-relative d-flex align-items-center">
        
        {/* MOBILE REGION: Logo & Einkaufswagen */}
        <div className="d-flex align-items-center d-lg-none">
          <Navbar.Brand
            as={Link}
            to="/"
            className="bbs-brand me-2"
            aria-label="BBS II Leer - Zur Startseite"
            onClick={handleClose}
          >
            <img
              src={BBSLogo}
              alt=""
              className="bbs-logo ms-3"
              aria-hidden="true"
            />
            <span className="visually-hidden">BBS II Leer</span>
          </Navbar.Brand>
          
          <div className="mobile-cart-wrapper ms-2">
            <CartBadge />
          </div>
        </div>

        {/* DESKTOP REGION */}
        <div className="nav-center d-none d-lg-flex w-100 align-items-center justify-content-center">
          <Nav
            as="nav"
            aria-label="Hauptnavigation"
            className="align-items-center"
          >
            <Navbar.Brand
              as={Link}
              to="/"
              className="bbs-brand me-4"
              aria-label="BBS II Leer - Zur Startseite"
            >
              <img
                src={BBSLogo}
                alt=""
                className="bbs-logo"
                aria-hidden="true"
              />
            </Navbar.Brand>

            {menuItems.map((item) => (
              <Nav.Link
                key={item.to}
                as={Link}
                to={item.to}
                className={`d-flex align-items-center mx-1 ${location.pathname === item.to ? "active" : ""}`}
                aria-current={location.pathname === item.to ? "page" : undefined}
              >
                <span className="text-green-bbs d-flex align-items-center">
                  {IconMap[item.icon]}
                </span>
                {item.label}
              </Nav.Link>
            ))}

            <div
              className="ms-1 border-secondary d-flex align-items-center"
              role="group"
              aria-label="Kontakt Schnellwahl"
            >
              <a
                href="tel:+4949192750"
                className="d-flex align-items-center contact-link mx-2 text-gray-bbs"
                style={{ textDecoration: "none" }}
                aria-label="Anrufen: 0 4 9 1 9 2 7 5 0"
              >
                <Telephone className="me-1 text-green-bbs" aria-hidden="true" />
                0491-9275-0
              </a>
              <a
                href="mailto:info@bbs2leer.de"
                className="d-flex align-items-center contact-link mx-2 text-gray-bbs"
                style={{ textDecoration: "none" }}
                aria-label="E-Mail schreiben an info@bbs2leer.de"
              >
                <Envelope className="me-1 text-green-bbs" aria-hidden="true" />
                info@bbs2leer.de
              </a>
            </div>
            
            <div className="d-flex align-items-center ms-2">
              <CartBadge />
            </div>
          </Nav>
        </div>

        {/* Toggle Mobile */}
        <Navbar.Toggle
          aria-controls="offcanvasNavbar"
          aria-label="Menü öffnen"
          className="ms-auto d-lg-none"
        />

        {/* Mobile Offcanvas */}
        <Navbar.Offcanvas
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
          placement="end"
          className="d-lg-none"
          restoreFocus={false}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title id="offcanvasNavbarLabel">
              Hauptmenü
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav
              className="ms-auto text-end fs-5"
              as="nav"
              aria-label="Mobile Navigation"
            >
              {menuItems.map((item) => (
                <Nav.Link
                  key={item.to}
                  as={Link}
                  to={item.to}
                  className="d-flex align-items-center justify-content-end mb-3"
                  aria-current={location.pathname === item.to ? "page" : undefined}
                  onClick={handleClose} /* SCHLIESST DAS MENÜ BEIM KLICK */
                >
                  {item.label}
                  <span className="text-green-bbs ms-3">
                    {IconMap[item.icon]}
                  </span>
                </Nav.Link>
              ))}
            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Container>
    </Navbar>
  );
};

export default BBS2Navbar;